module.exports = __webpack_public_path__ + "static/Recruit04_03-1-20633c8343c0be6f6a5cb680dbbdac29.png";